import React, { Suspense, useRef } from 'react'
import { useRouter } from 'next/router'
// Sanity
import { getClient } from '../client'
import { propsSanity, groqSanityPageQuery, groqAllBlogPostsQuery } from '../lib/libFunctions'

// Styles
import { base } from '../styles/base/_allBase.styles'
const {
  GridItem_HeaderSection,
  GridContainer_Page_Layout,
  Page_Main_Grid_Container,
} = base
// Components
import SEO from '../components/seo-head/seo-head'
import SectionOne from '../components/section-one/section-one.jsx'
import { GuidePlanning, LocalOverview } from '../components/guide-planning/guide-planning.component'
import BlogGridSection from '../components/blogGridSection/BlogGridSection'
import { HOME_GUIDE_IDS, selectGuides } from '../lib/guide-presentation.mjs'
import { FeaturedTopicsSection } from '../components/featured-topics-section/featured-topics-section'
import { Header } from '../components/header/header'
import { Footer } from '../components/footer/footer.component.jsx'
import ActionPanel from '../components/action-panel/action-panel.component'

function Home(props) {
  const sectionOneRef = useRef()
  const router = useRouter()

  const { header, dragSlider, featuredTopics, actionPanel } = props.data.data
  const { seo } = props.data

  return (
    <GridContainer_Page_Layout>
      <SEO seo={seo} router={router} header={header} />
      <GridItem_HeaderSection>
        <header ref={sectionOneRef}>
          <Header />
        </header>
      </GridItem_HeaderSection>
      <main>
        <Page_Main_Grid_Container>
          <Suspense fallback={<div>Loading...</div>}>
            <SectionOne header={{...header, subheader: header.subheader?.replace(/accomodation/g, 'accommodation')}} variant="destination" ctaHref="#plan-your-visit" ctaLabel="Plan your visit" />
            <GuidePlanning module={dragSlider} />
            <FeaturedTopicsSection topics={featuredTopics?.topics || []} module={featuredTopics} />
            <LocalOverview module={dragSlider} />
            <BlogGridSection posts={props.guides} heading="Guides for your trip" compact />
            {actionPanel && <ActionPanel data={actionPanel} />}
          </Suspense>
          <Footer />
        </Page_Main_Grid_Container>
      </main>
    </GridContainer_Page_Layout>
  )
}

export async function getServerSideProps() {
  const query = groqSanityPageQuery('home-page')
  const [data, posts] = await Promise.all([getClient().fetch(query, {}), getClient().fetch(groqAllBlogPostsQuery())])

  return {
    props: {
      data: propsSanity(data),
      guides: selectGuides(posts, HOME_GUIDE_IDS),
    },
  }
}

export default Home
